export function isProduction() {
    return ENVIRONMENT === "production";
}
export function isLocal() {
    return ENVIRONMENT === "local";
}
